export default __webpack_public_path__ + "static/media/file-circle-icons-radio-svg-wikimedia-commons-0.16f5b30b.png";